import styled from 'styled-components';

export const FiveInOneStyled = styled.div`
  .offboxBanner {
    display: flex;
    flex: 1 1 25%;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      margin-top: 15px;
      max-width: calc(25% - 15px);
      flex-grow: 1;
      &:first-child {
        width: 100%;
        min-width: 100%;
      }
    }
  }
  .titleBar {
    .title {
      margin: 0;
    }
  }
  .container {
    padding: 22px 0;
  }
  .imageBox {
    width: 100%;
    border-radius: 8px;
    margin: 0 0 30px 0;
    position: relative;
    background-size: cover;
    background-position: top center;

    > div,
    > div + div {
      position: relative !important;

      > img {
        width: 100% !important;
        height: 100% !important;
        border-radius: 8px;
        position: relative !important;
      }
    }
    .offLabel {
      width: 54px;
      height: 54px;
      background: ${(props) => props.theme.blue.dark};
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: ${(props) => props.theme.color.white};
      font-size: 14px;
      line-height: 1;
      font-weight: 800;
      text-transform: uppercase;
      position: absolute;
      bottom: 16px;
      right: 16px;
      z-index: 1;
    }
  }
  .emergency {
    width: 100%;
    padding: 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 30px 0 0 0;
    background: ${(props) => props.theme.verification.red.off};

    .btn {
      margin: 0;
    }

    .action {
      a {
        text-decoration: none;
      }
    }

    .action {
      a {
        text-decoration: none;
      }
    }

    .text {
      display: flex;
      flex-direction: row;
      align-items: center;

      .main {
        font-size: 18px;
        font-weight: 700;
        margin-right: 20px;
      }
      .sub {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  @media (max-width: 820px) {
    padding: 0 0 5px 0;

    .container {
      padding: 16px 0;
    }

    .imageBox {
      margin: 0;
    }

    .titleBar {
      .title {
        margin: 0;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 0;
    .offboxBanner {
      > div {
        margin-top: 7px;
        max-width: calc(25% - 7px);
        flex-grow: 1;
        &:first-child {
          width: 100%;
          min-width: 100%;
        }
      }
    }

    .container {
      padding: 0;
      .titleBar {
        padding: 0;

        .title {
          margin: 0;
        }
      }
    }

    .row {
      flex-direction: row;
    }

    .emergency {
      flex-direction: column;
      align-items: center;

      .text {
        flex-direction: column;
        align-items: center;

        .main {
          margin: 0 0 10px 0;
        }
        .sub {
          text-align: center;
          margin: 0 0 10px 0;
        }
      }
    }
  }
`;
